import { AmplifyAuth } from "./components/amplify_auth";

function App() {
  return <AmplifyAuth />;
}

export { App };
